export default __webpack_public_path__ + "static/bg-triangles-631952f868b35c259daedd014d2495c2.svg";